import { PaymentStatus, PaymentType } from '@/schemas/payments.schema'
import Badge, { ColorType } from '../Badge'
import { useTranslation } from 'react-i18next'

interface Props {
  paymentStatus: PaymentStatus
  paymentType: PaymentType
}

function getColor(value: PaymentStatus): ColorType {
  if (value === 'Approved') {
    return 'Positive'
  }

  const declinedStatuses: PaymentStatus[] = [
    'Declined by Applicant',
    'Declined by Admin',
    'Declined by Applicant',
    'Declined by Provider',
    'Refunded by Provider',
    'Declined',
    'Declined by Applicant',
    'Declined by Provider',
    'Refunded by Provider',
    'Appeal Declined by Admin',
  ]

  if (declinedStatuses.includes(value)) {
    return 'Negative'
  }
  const inReviewStatuses: PaymentStatus[] = [
    'In review - LEGACY DO NOT USE',
    'In review Admin',
    'In review Provider',
    'In review Applicant',

    'Appeal awaiting decision',
    'Partially Refunded by Provider',
  ]
  if (inReviewStatuses.includes(value)) {
    return 'Notice'
  }

  return 'Neutral'
}

function getBadgeName(
  name: PaymentStatus,
  type: PaymentType,
  t: (key: string) => string
): string {
  if (type === 'Marketplace' && name === 'In review Applicant') {
    return (
      t('payments_table.did_you_receive_item') || 'Did you receive the item?'
    )
  }

  if (name === 'In review - LEGACY DO NOT USE') {
    return t('payments_table.in_review') || 'In review'
  }

  if (name === 'Partially Refunded by Provider') {
    return (
      t('payments_table.partially_refunded_by_provider') ||
      'Partially Refunded by Provider'
    )
  }

  const normalized = name.toLowerCase()

  if (normalized.startsWith('in review')) {
    const role = normalized.replace('in review', '').trim()
    return `${t('payments_table.in_review')} ${t(`payments_table.${role.toLowerCase()}`)}`
  }

  if (normalized.startsWith('declined by')) {
    const role = normalized.replace('declined by', '').trim()
    return `${t('payments_table.declined_by')} ${t(`payments_table.${role.toLowerCase()}`)}`
  }

  return name
}

function PaymentStatusBadge(props: Props) {
  const { paymentStatus, paymentType } = props

  const { t } = useTranslation()

  return (
    <Badge semanticColor={getColor(paymentStatus)}>
      {getBadgeName(paymentStatus, paymentType, t)}
    </Badge>
  )
}

export default PaymentStatusBadge
